import { FormBanner } from 'shared/landingBuyer/components/FormBanner';
import { FormContainer } from '../FormContainer';

export const FormBannerContainer: React.FC = () => {
  return (
    <FormBanner
      form={
        <FormContainer
          theme="white"
          title={'Не тратьте время — доверьтесь профи'}
          subtitle={'Перезвоним, изучим ваш запрос и начнём подбор агента'}
          btnTitle={'Позвоните мне'}
        />
      }
    />
  );
};
